import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Controller } from "react-hook-form";
import { InfoContainer, Text } from "$components";
import FileUploader from "$components/FileUploader/FileUploader";
import { useStyles } from "../styles";
import { ProjectDetailsLogic } from "../types";

type ProjectAttachmentsProps = Pick<
  ProjectDetailsLogic,
  "project" | "isProjectDisabled" | "canEdit" | "isAdminUser" | "control"
>;

export default function ProjectAttachments({
  project,
  isProjectDisabled,
  canEdit,
  isAdminUser,
  control,
}: ProjectAttachmentsProps) {
  const clasx = useStyles();

  return (
    <InfoContainer
      leftHeader={
        <div className={clasx.infoHeader}>
          <AttachFileIcon />
          <Text type="h3">Pièces jointes</Text>
        </div>
      }
      className={clasx.attachements}
    >
      {project?.medias?.length > 0 && (
        <div>
          <Text type="h3">Liste des médias</Text>
        </div>
      )}
      <form>
        <Controller
          control={control}
          name="medias"
          render={({ field: { onChange, value } }) => (
            <FileUploader
              value={value}
              onChange={(values) => {
                onChange(values);
              }}
              isAdmin={isAdminUser}
              type="project"
              company={(project?.company as any)?._id}
              id={project?._id ?? undefined}
              isEdit={false}
              isLargeVersion
              isReadOnly={isProjectDisabled || !canEdit}
            />
          )}
        />
      </form>
    </InfoContainer>
  );
}
